import _lib from '../_lib';
import active from './active/index';
import {WatchNavigation} from '@/store/modules/fsm/messages';
import { clearAllWatches } from '@/mutation-types';;

export default ({tree,parent,api}) => {
  let regionName = 'watch';
  let activations = [
    {
      name: 'watch',
      test: api.messageIs(WatchNavigation)
    }
  ];
  let activeIndex = active;
  let readyToDormant = ({context}) => context.commit(`login/watch/${clearAllWatches}`,null,{root:true});
  let func = _lib({regionName,activations,activeIndex,readyToDormant});
  return func({tree,parent,api});
};

